export var CAMPAIGN_TYPE = {
  PAID: 'paid',
  ORGANIC: 'organic'
};
export var campaignMapping = {
  google: ['cpc'],
  sms: ['exponea'],
  clm: ['jainsys', 'mail', 'push', 'sms', 'website', 'whatsapp'],
  spartacus: ['birdinfotech', 'caesar', 'technomate'],
  facebook: ['paid'],
  'facebook instagram': ['social'],
  'facebook+instagram': ['social']
};
export var alwaysPaidSource = ['affiliate', 'drp', 'affi'];
export var alwaysPaidMedium = ['referral'];
export var UTM_PARAMS_KEY = 'utmpk';
export default {
  CAMPAIGN_TYPE: CAMPAIGN_TYPE,
  UTM_PARAMS_KEY: UTM_PARAMS_KEY,
  campaignMapping: campaignMapping,
  alwaysPaidSource: alwaysPaidSource,
  alwaysPaidMedium: alwaysPaidMedium
};